// „Опресни" в лентата на справките: презарежда заявките, които страницата
// рисува, и казва дали някоя от тях тегли в момента (иконата се върти).
// Изключена заявка (`enabled: false` — напр. в локален режим или „Продадени
// рецепти", докато гледаш продуктите) НЕ се пуска: `refetch()` на React Query
// минава покрай `enabled`, затова тя се прескача по `isEnabled`.
export type RefreshableQuery = {
  refetch: () => Promise<unknown>;
  isFetching: boolean;
  isEnabled: boolean;
};

export const refreshOf = (...queries: RefreshableQuery[]) => {
  const refreshing = queries.some((query) => query.isFetching);
  const refresh = () => {
    // Вече тегли → новата заявка само би прекъснала текущата
    if (refreshing) return;
    for (const query of queries) if (query.isEnabled) void query.refetch();
  };
  return { refresh, refreshing };
};
